"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.llamadaRecibidaConverter = exports.contactoTelefonoConverter = exports.leadConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const leadConverter = {
    toFirestore(lead) {
        return lead;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            fechaTimestamp: data.fechaTimestamp,
            nombre: data.nombre,
            telefono: data.telefono,
            mail: data.mail,
            rut: data.rut,
            sobreEl: data.sobreEl,
            esLiteralE: data.esLiteralE ?? false,
            nuevoLead: data.nuevoLead,
            notas: data.notas,
            handy: data.handy,
            handyCFE: data.handyCFE,
            registrado: data.registrado,
            query: data.query
        };
    }
};
exports.leadConverter = leadConverter;
const contactoTelefonoConverter = {
    toFirestore(contacto) {
        const obj = contacto;
        obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({
            buscableParcialPor: [obj.nombre, obj.mail, obj.telefono],
            buscableExactoPor: [obj.mail, obj.telefono, obj.nombre]
        });
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: snapshot.id,
            nombre: data.nombre,
            telefono: data.telefono,
            empresas: data.empresas,
            empresasEsContador: data.empresasEsContador,
            historialLlamadas: data.historialLlamadas,
            llamadaEntrante: data.llamadaEntrante,
            ultimaSincronizacionViejoFixed: data.ultimaSincronizacionViejoFixed,
            esContador: data.esContador,
            esLead: data.esLead,
            mail: data.mail ?? "",
            enviarSecuencia: data.enviarSecuencia ?? false,
            enviosSecuenciasHuspot: data.enviosSecuenciasHuspot ?? {},
            fechaCreado: data.fechaCreado ?? 0,
            historialMails: data.historialMails ?? [],
            mailsId: data.mailsId ?? []
        };
    }
};
exports.contactoTelefonoConverter = contactoTelefonoConverter;
const llamadaRecibidaConverter = {
    toFirestore(llamada) {
        return llamada;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            numero: data.numero,
            hora: data.hora,
            atendida: data.atendida,
            notas: data.notas,
            contactadoPor: data.contactadoPor,
            contactadoHora: data.contactadoHora
        };
    }
};
exports.llamadaRecibidaConverter = llamadaRecibidaConverter;
